import React from "react";
import PropTypes from "prop-types";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-designer-category-rail.css";

const ItemPropType = PropTypes.shape({
    title: PropTypes.string,
    imgUrl: PropTypes.string,
    url: PropTypes.string,
});

export function HomepageDCItem({ item }) {
    return (
        <div className={styles.homepageDCItem}>
            <LazyLoadImage className={styles.homepageDCImg} src={item.img_url} alt={item.title} />
            <a className={styles.homepageDCLink} href={item.url}>
                {item.title}
            </a>
        </div>
    );
}

HomepageDCItem.propTypes = {
    item: ItemPropType,
};

export function HomepageDesignerCategoryRail({ items }) {
    return (
        <Rail
            className={styles.homepageDCRail}
            analyticsLabel={"homepage_store_rail"}
            title={""}
            leftButtonStyle={styles.homepageDCRailButtonLeft}
            rightButtonStyle={styles.homepageDCRailButtonRight}
        >
            {items.map((item) => {
                return <HomepageDCItem key={item.url} item={item} />;
            })}
        </Rail>
    );
}

HomepageDesignerCategoryRail.propTypes = {
    items: PropTypes.arrayOf(ItemPropType).isRequired,
};

export default HomepageDesignerCategoryRail;
